import {
	CUSTOM_ELEMENTS_SCHEMA,
	Component,
	ElementRef,
	ViewChild,
	afterNextRender,
	input,
} from '@angular/core';
import { AccommodationLocations } from '@uc/web/shared/data-models';
import { AccommodationCardComponent } from '../accommodation-card/accommodation-card.component';
import { Product } from '@uc/shared/data-models';

@Component({
	selector: 'uc-accommodation-carousel',
	templateUrl: './accommodation-carousel.component.html',
	imports: [AccommodationCardComponent],
	schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class AccommodationCarouselComponent {
	@ViewChild('swiperRef', { static: true }) protected swiperRef: ElementRef | undefined;

	uniName = input.required<string>();
	ugSearchOrderPosition = input<number | null>(null);
	accommodationLocations = input<AccommodationLocations[] | undefined>();
	externalUrl = input<string>();
	accommodationRank = input<number | undefined>();
	accommodationRating = input<number | undefined>();
	universityUrl = input<string>();
	uniId = input<number | null>(null);
	product = input<Product | null>(null);

	constructor() {
		afterNextRender(() => {
			this._initSwiper();
		});
	}

	setValue(): number {
		if (this.accommodationLocations?.length === 2) {
			return 2;
		}
		return 3;
	}

	private _initSwiper() {
		const config = {
			slidesPerView: 1.1,
			spaceBetween: 24,
			loop: false,
			navigation: {
				nextEl: '.swiper-button-next-accommodation',
				prevEl: '.swiper-button-prev-accommodation',
			},
			pagination: {
				type: 'fraction',
				el: '.carousel-index-accommodation',
			},
			breakpoints: {
				// when window width is >= 480px
				590: {
					slidesPerView: 2,
					spaceBetween: 32,
					slidesPerGroup: 2,
				},
				// when window width is >= 968px
				879: {
					slidesPerView: this.setValue(),
					spaceBetween: 32,
					slidesPerGroup: this.setValue(),
				},
			},
		};

		const swiperEl = this.swiperRef?.nativeElement;
		Object.assign(swiperEl, config);

		swiperEl.initialize();
	}
}
